export class VoucherCreditException extends Error {
  constructor(public balance: number) {
    super('Not enough balance.')
  }
}
